import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserAddLiner24 = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M3.41016 22C3.41016 18.13 7.26015 15 12.0002 15C12.9602 15 13.8902 15.13 14.7602 15.37M19.4899 17.98H16.5099M18.0002 16.52V19.51M17.0002 7C17.0002 9.76142 14.7616 12 12.0002 12C9.23873 12 7.00015 9.76142 7.00015 7C7.00015 4.23858 9.23873 2 12.0002 2C14.7616 2 17.0002 4.23858 17.0002 7ZM22.0002 18C22.0002 18.32 21.9602 18.63 21.8802 18.93C21.7902 19.33 21.6302 19.72 21.4202 20.06C20.7302 21.22 19.4602 22 18.0002 22C16.9702 22 16.0401 21.61 15.3401 20.97C15.0401 20.71 14.7801 20.4 14.5801 20.06C14.2101 19.46 14.0002 18.75 14.0002 18C14.0002 16.92 14.4302 15.93 15.1302 15.21C15.8602 14.46 16.8802 14 18.0002 14C19.1802 14 20.2502 14.51 20.9702 15.33C21.6102 16.04 22.0002 16.98 22.0002 18Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});